var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component",on:{"toggleSound":_vm.toggleSound}},[_c('router-view',{attrs:{"latestDetection":_vm.latestDetection,"latestViolation":_vm.latestViolation}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }